module.exports = __webpack_public_path__ + "img/Group 137.d7ce7b6e.svg";